import React from 'react';
import { Navigate, useParams } from 'react-router-dom';
import useVehiclePurchaseVm from '|/app/vehicle/[vehicleId]/use-vehicle-purchase-vm';

const VehiclePurchase = () => {
  const { vehicleId: vehicleIdString = null } = useParams<{
    vehicleId?: string;
  }>();
  const { newRoute } = useVehiclePurchaseVm(vehicleIdString);

  if (newRoute !== null) {
    return <Navigate to={newRoute} replace={true} />;
  }

  return null;
};

export default VehiclePurchase;
